export default {
  sidebar: {
    agentError: 'Failed to get a response from the agent.',
    creditsExhausted:
      'This workspace has used its Khorium Agent allowance. Contact your administrator to continue.',
    notEntitled:
      "You don't have an active seat or subscription for Khorium Agent in this workspace. Ask your workspace admin to assign you a seat, or contact support.",
    updateSessionError: 'Failed to update session',
    renameSessionError: 'Failed to rename session',
    pinSessionError: 'Failed to pin session',
    loadHistoryError: 'Failed to load session history',
    loadTranscriptTimeout:
      'This conversation is taking too long to load. Try again, or start a new chat.',
    loadTranscriptTooLarge:
      'This conversation is too large to load. Start a new chat to keep going.',
    resizeHandle: 'Resize chat panel',
    untitled: 'Untitled',
    updatedPrefix: 'Updated',
    newChat: 'New chat',
    newChatTooltip: 'New Chat',
    showHistory: 'Show chat history',
    hideHistory: 'Hide chat history',
    showHistoryTooltip: 'Show Chat History',
    hideHistoryTooltip: 'Hide Chat History',
    restoringSession: 'Restoring your conversation…',
    maximize: 'Enter full screen',
    minimize: 'Exit full screen',
    maximizeTooltip: 'Enter Full Screen',
    minimizeTooltip: 'Exit Full Screen',
    collapse: 'Collapse chat',
    collapseTooltip: 'Collapse Chat',
  },
  attachment: {
    imagePreviewAlt: 'Image Preview',
    imagePreviewTitle: 'Image Attachment Preview',
    thumbAlt: 'Attachment preview',
    typeImage: 'Image',
    typeDocument: 'Document',
    typeFile: 'File',
    tileLabel: '{{type}} attachment',
    chipLabel: '{{type}} attachment: {{name}}',
    removeFile: 'Remove file',
    addAttachment: 'Attach a CAD part',
    addAttachmentTooltip: 'Attach a CAD part ({{types}})',
    uploadFailed: 'Upload failed',
  },
  sessionList: {
    loadError: 'Failed to load sessions',
    header: 'Chat History',
    searchPlaceholder: 'Search chats...',
    loading: 'Loading chat history...',
    emptyNoMatch: 'No matching chats.',
    emptyNone: 'No chat history yet.',
    emptyNoAutoRetry: 'No AI retry transcripts yet.',
    scopeLabel: 'Session type',
    scopeChats: 'Chats',
    scopeAutoRetry: 'AI retries',
    pinned: 'Pinned',
    recent: 'Recent',
    untitled: 'Untitled chat',
    unpin: 'Unpin chat',
    pin: 'Pin chat',
    unpinTooltip: 'Unpin Chat',
    pinTooltip: 'Pin Chat',
    rename: 'Rename chat',
    renameTooltip: 'Rename Chat',
  },
  thread: {
    helpful: 'Helpful',
    unhelpful: 'Not helpful',
    welcomeTitle: 'Hello there!',
    welcomeSubtitle: 'How can I help you today?',
    scrollToBottom: 'Scroll to bottom',
    inputPlaceholder: 'Send a message...',
    inputLabel: 'Message input',
    screenshotOn: 'Viewport screenshot on',
    screenshotOff: 'Viewport screenshot off',
    toggleScreenshot: 'Toggle viewport screenshot',
    approvalMode: 'Tool approval',
    approvalAuto: 'Auto approve',
    approvalAutoShort: 'Auto',
    approvalManual: 'Manual — ask first',
    approvalManualShort: 'Manual',
    sendMessage: 'Send message',
    waitingForUpload: 'Waiting for {{file}} to finish uploading',
    waitingForApproval: 'Answer the confirmation above first',
    stopGenerating: 'Stop generating',
    queueMessage: 'Send after this reply',
    queuedHeading: 'Queued',
    queueRemove: 'Remove from queue',
    connectionLostWaiting: 'Connection lost. Waiting for the reply to finish.',
    connectionLost:
      'Unable to confirm whether the agent is still running. Refresh to check again.',
    runWorking: 'Agent is working. The reply will appear here when ready.',
    runAwaitingClient:
      'This run needs an action in the original browser. Check its outcome before repeating it.',
    runFailed:
      'The agent could not finish this run. Any saved progress is shown above.',
    runCancelled: 'This run was stopped. Any saved progress is shown above.',
    copy: 'Copy',
    refresh: 'Refresh',
    refreshHeldForApproval: 'Answer the question above first',
    more: 'More',
    exportMarkdown: 'Export as Markdown',
    edit: 'Edit',
    editCancel: 'Cancel',
    editUpdate: 'Update',
    branchPrevious: 'Previous',
    branchNext: 'Next',
  },
  approval: {
    titleBackend: 'Let the assistant do this?',
    subtitleBackend:
      'It changes your saved work or starts a run that costs money.',
    allowOnce: 'Allow once',
    deny: 'Deny',
    working: 'Working…',
    cancelled: 'Action cancelled',
    approved: 'Action approved',
    skipped: 'Action skipped',
    failed: 'Action failed',
    askedBecauseManual: 'Asked because approval is Manual',
    handCalcSet: 'Adds or replaces {{count}}:',
    handCalcRemove: 'Takes off {{count}}:',
    handCalcNew: 'new',
    handCalcReplacesEngineer: "replaces the engineer's",
    handCalcReplacesAgent: "replaces the AI's",
    handCalcEngineers: "the engineer's",
    handCalcAgents: "the AI's",
    handCalcMore: 'and {{count}} more',
  },
  toolCalls: {
    verbMeshSettings: 'Set mesh sizing',
    verbBoundaryLayer: 'Set boundary layer',
    verbViewerSettings: 'Set viewer',
    verbDomainParams: 'Set flow domain',
    verbInspect: 'Read the setup',
    verbPrepare: 'Prepare the mesh',
    verbRun: 'Run the study',
    verbSimopsDraft: 'Edit the SimOps setup',
    verbRetryPoint: 'Retry a design point',
    usedTool: 'Used tool',
    targetMeshSetup: 'Mesh Setup',
    targetViewer: 'Viewer',
    targetDomain: 'Flow Domain',
    targetGuidance: 'Khorium guidance',
    valueOn: 'on',
    valueOff: 'off',
    noChange: 'Nothing changed',
    arguments: 'Arguments',
    result: 'Result',
    group_one: '{{count}} tool call',
    group_other: '{{count}} tool calls',
    retry: 'Retry',
    skip: 'Skip',
    retryMessage: 'Retry {{step}}',
    skipMessage: 'Skip {{step}}',
    sentBack: 'Sent back to the assistant to try again',
    openStudy: 'Open the study in SimOps',
    openDesignPoint: 'Open the design point in SimOps',
    openMesh: 'Open the mesh in MeshGen',
    openPage: 'Open the page',
    openGeometry: 'Open it in MeshGen?',
    openGeometryFailed: 'Could not open MeshGen. Try again.',
  },
  reasoning: {
    inProgress: 'Thinking…',
    unfinished: 'Thinking (unfinished)',
    done: 'Thinking',
  },
  plan: {
    summary: 'Plan {{done}}/{{total}}',
    summaryWithStep: 'Plan {{done}}/{{total}} · {{step}}',
  },
  linkedPages: {
    button: 'Linked pages',
    buttonTooltip: 'Linked Pages',
    title: 'Linked in this chat',
    empty: 'Pages the assistant links to show up here.',
    detail: {
      dp: 'DP',
      mesh: 'Mesh',
    },
  },
} as const;
